// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 227 ? "chunk-echarts" : chunkId) + "." + {"10":"4e0bd85d","11":"c7a631fe","227":"a1822c1c","474":"682828e0","505":"7ad2297c","638":"c64c7e10","641":"9c6a0f73","652":"9e036e50","694":"cabef0d7","799":"40602c06","853":"8e25b076","854":"9c361963","924":"da7094c6"}[chunkId] + ".js";
};